module.exports = __webpack_public_path__ + "img/logo_azul.5cb51cb.png";